
import yxpapi from '@yxpapi';
let commonApi = new yxpapi.PHPAPI({
    // 获取用户上次访问位置
    getTeacherSystemType: {
        url: '/api/class/teacher/getTeacherSystemType',
        method: 'get',
    },
    /* 模拟登录 */
    doLogin: {
        url: '/api/user/account/login',
        options: {
            auth: false,
        },
    },
    /* 获取用户可访问的路由 */
    getRouterMap: {
        url: '/api/user/address/member/listUserAppPrivileges',
        method: 'get',
    },
    /* 获取个人之下的单位信息 */
    getMySubordinate: {
        url: '/api/user/account/getOrgInfo',
        method: 'get',
    },
    /* 查询是否有行政校或培训校学校 */
    getStudentManageMenu: {
        url: '/api/user/account/getStudentManageMenu',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
        },
    },
    /* 获取用户身份 */
    forIdentity: {
        url: '/api/user/account/getIdentityInOrg',
        method: 'get',
    },
    /* 获取所有地域 */
    getArea: {
        url: '/api/user/area/getArea',
        method: 'get',
    },
    /* 获取国家 */
    getCountry: {
        url: '/api/user/area/listCountry',
        method: 'get',
    },
    /* 获取省份 */
    getProvinces: {
        url: '/api/user/area/province/list',
        method: 'get',
    },
    /* 获取省份访问记录 */
    getProvincesRecord: {
        url: '/api/user/area/getRecentProvinces',
        method: 'get',
    },
    /* 获取城市 */
    operatLog: {
        url: '/api/user/area/province/getCity',
        method: 'get',
    },
    /* 获取县 */
    getCounty: {
        url: '/api/user/area/province/city/listDistrict',
        method: 'get',
    },
    /* 获取操作日志模块编号 */
    getModuleNum: {
        url: '/api/log/portalAction/module/list',
        method: 'get',
    },
    /* 记录最近一次选择的身份 */
    saveIdentity: {
        url: '/api/user/account/saveIdentity',
        options: {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            },
        },
    },
    /* 获取操合作项目 */
    getCooperativeTag: {
        url: '/api/user/org/school/cooperative/list',
        method: 'get',
    },
    /* 获取权限范围内的学校 */
    getSchoolInfoByRole: {
        url: '/api/class/school/getSchoolInfoByRole',
        method: 'get',
    },
    /* 获取用户能访问的路由 */
    getActionList: {
        url: '/api/permit/permission/getUserModuleActionList',
        method: 'get',
    },
    /**/
    /* 通用查询条件 */
    dictionary: {
        url: '/api/knowledge/condition/dictionary',
        method: 'get',
        before (opt, next) {
            let query = '';
            Object.entries(opt.data).forEach(([k, v = '']) => {
                query += '&' + k + '=' + v;
            });
            next({
                url: opt.url + '?' + query.slice(1),
                data: {},
            });
        },
    },

    /* 获取用户机构的学制和学段 */
    getOrgedusystem: {
        url: '/api/user/org/school/eduSystem',
        method: 'get',
    },
    // 获取用户是否被加入过项目中的接口
    isProjectUser: {
        url: '/api/project/projectManage/isProjectUser',
        method: 'get',
    },
});

export default commonApi;
export { commonApi };
